// extracted by mini-css-extract-plugin
export default {"tableContainer":"reply-enquiry-table_tableContainer__Q8Gva","pdfIcon":"reply-enquiry-table_pdfIcon__gm3ep"};